import * as Yup from "yup";

export const InitSchema = Yup.object({
  appId:           Yup.string().required("App ID is required"),
  secretKey:       Yup.string().required("Secret Key is required"),
  orderId:         Yup.string().required("Order ID is required"),
  amount:          Yup.string()
                     .required("Amount is required")
                     .matches(/^(0*[1-9][0-9]*([.][0-9]+)?|0+[.][0-9]*[1-9][0-9]*)$/, "Enter a valid amount"),
  custEmail:       Yup.string().required("Email is required").email("Enter a valid email"),
  custPhone:       Yup.string().required("Phone is required").matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number"),
  custFirstName:   Yup.string().required("First name is required"),
  currencyCode:    Yup.string().required("Currency Code is required"),
  returnUrl:       Yup.string(),           // optional — sent as "" when blank
  transactionType: Yup.string().required("Transaction Type is required"),
  productDesc:     Yup.string().required("Product Description is required"),
  userIpAddress:   Yup.string(),           // optional — defaults to 179.1.44.89
});

